import { render, staticRenderFns } from "./Protocol.vue?vue&type=template&id=2133a46f&scoped=true"
import script from "./Protocol.vue?vue&type=script&lang=js"
export * from "./Protocol.vue?vue&type=script&lang=js"
import style0 from "./Protocol.vue?vue&type=style&index=0&id=2133a46f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2133a46f",
  null
  
)

export default component.exports